export default {
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["अन्य सुरक्षा सेटिंग्स"])}
}